import { motion } from 'framer-motion';

interface WhatsAppDiagnosticProps {
  city: string;
}

export function WhatsAppDiagnostic({ city }: WhatsAppDiagnosticProps) {
  return (
    <section id="diagnostic" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-block bg-green-500/10 text-green-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-whatsapp-line mr-2"></i>
              Diagnostic Vidéo Gratuit
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Comment ça marche ?
            </h2>

            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-500 text-white rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0">
                  1
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Contactez-nous sur WhatsApp</h3>
                  <p className="text-gray-600">Cliquez sur le bouton ci-dessous pour démarrer une conversation</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-500 text-white rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0">
                  2
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Envoyez des photos ou vidéo</h3>
                  <p className="text-gray-600">Montrez-nous votre fenêtre ou baie vitrée à réparer</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-500 text-white rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0">
                  3
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Recevez votre diagnostic</h3>
                  <p className="text-gray-600">Notre expert analyse et vous propose une solution adaptée</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-10">
              <div className="bg-gray-50 rounded-2xl p-6 text-center">
                <div className="text-3xl font-bold text-teal mb-2">0€</div>
                <div className="text-sm text-gray-600">Diagnostic gratuit</div>
              </div>
              <div className="bg-gray-50 rounded-2xl p-6 text-center">
                <div className="text-3xl font-bold text-teal mb-2">&lt;2h</div>
                <div className="text-sm text-gray-600">Réponse rapide</div>
              </div>
              <div className="bg-gray-50 rounded-2xl p-6 text-center">
                <div className="text-3xl font-bold text-teal mb-2">Expert</div>
                <div className="text-sm text-gray-600">Conseil pro</div>
              </div>
              <div className="bg-gray-50 rounded-2xl p-6 text-center">
                <div className="text-3xl font-bold text-teal mb-2">7j/7</div>
                <div className="text-sm text-gray-600">Disponible</div>
              </div>
            </div>

            <a
              href={`https://wa.me/33745883392?text=Bonjour,%20je%20souhaite%20un%20diagnostic%20pour%20ma%20fenêtre%20à%20${city}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white px-8 py-5 rounded-2xl font-bold text-lg transition-all hover:-translate-y-1 hover:shadow-2xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-3xl"></i>
              <span>Démarrer le Diagnostic WhatsApp</span>
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl w-full h-[600px]">
              <img
                src="https://public.readdy.ai/ai/img_res/a0a699514f39e43ec8581caad986d96a.jpg"
                alt="Diagnostic WhatsApp"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-8 left-8 bg-white rounded-2xl px-6 py-3 shadow-lg">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                  <span className="font-bold text-gray-900">Simple &amp; Rapide</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}